





























import Vue, { PropType } from 'vue';

export default Vue.extend({
  components: {},
  props: {
    columnList: {
      type: Array as PropType<Array<string>>,
      default: [],
    },
    rowList: {
      type: Array as PropType<Array<Array<unknown>>>,
    },
  },
  data() {
    return {};
  },
  computed: {},
});
